import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, Attribute, ViewChild
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl, AbstractControl, Validator, ValidatorFn
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {UserContext} from '../services/user-context';
import {FileInfo, FileRestrictions, SelectEvent, UploadComponent} from '@progress/kendo-angular-upload';
import {ApiService} from '../services/api';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

@Component({
  selector: 'app-password-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'password-dialog.template.html',
  styles: [
    "app-password-dialog mat-dialog-container {padding:0;}",
    "app-password-dialog mat-dialog-content.mat-dialog-content {background:#f7fafc;padding:24px;}",
    "app-password-dialog mat-dialog-actions {display:flex;flex-direction: row;justify-content: space-between;}"
  ]
})

export class PasswordDialogComponent implements OnInit {
  public form: FormGroup;

  user:any;
  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<PasswordDialogComponent>,
              private userContext: UserContext,
              public httpClient: HttpClient,
              private api: ApiService,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.user = data;
  }

  public ngOnInit(): void {
    this.buildForm();
  }

  public buildForm() {
    this.form = this.formBuilder.group({
      password: new FormControl('', this.data.user ? [Validators.minLength(8)] : [
        Validators.required,
        Validators.minLength(8),
        equalityValidator('confirm', false)
      ]),
      confirm: new FormControl('', this.data.user ? [Validators.minLength(8)] : [
        Validators.required,
        Validators.minLength(8),
        equalityValidator('password', true)
      ]),

    });
  }

  public save() {
    this.dialogRef.close({id:this.user.id, password: this.form.value.password});
  }

  public cancel() {
    this.dialogRef.close();
  }
}

export function equalityValidator(equalTo: string, hostError: boolean): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    const compareTo = control.root.get(equalTo);
    if ( hostError ) {
      return !compareTo || compareTo.value === control.value ? null : {'equalTo': {value: false}};
    } else {
      if ( compareTo && compareTo.touched ) {
        if ( compareTo.value !== control.value ) {
          compareTo.setErrors({'equalTo': {value: false}});
        } else {
          compareTo.setErrors( null );
        }
      }
      return null;
    }
  };
}
